import { Injectable } from "@angular/core";
import { Query } from '@datorama/akita';
import { UserState, UserStore } from './user.store';
import { CookieService } from 'ngx-cookie';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { Auth } from 'aws-amplify';
import { switchMap, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserQuery extends Query<UserState>{
    readonly tokenName = 'oneCG_token';
    readonly regionName = 'oneCG_region';
      SamlUserKey:string='SamlUser';
    UserName="abc";
    Password="test";
    private _region: string = '';
 MemberShipAPIRes:any
    message=''
    constructor(protected store: UserStore,
        private cookie: CookieService,
        private router: Router) {
        super(store);
    }

    user() {
        return this.select(user => {
            return user.data
        });
    }

    getToken() {
        return this.cookie.get(this.tokenName);
    }
    //new added on 12th may
    getTokenForAPI(): string {
        return this.getToken();
      }
      
    setToken(token) {
        return this.cookie.put(this.tokenName, token);
       
    }

    getUserName() {
        return this.UserName
       // return this.cookie.get(this.UserName);
    }

    setUserName(username) {
        this.UserName=username;
       // return this.cookie.put(this.UserName, username);
    }
    getPassword() {
        return this.Password
        //return this.cookie.get(this.Password);
    }

    setPassword(password) {
        this.Password=password
      //  return this.cookie.put(this.Password, password);
    }
    alreadyLogged() {
        return this.select(user => {
            return user.data;
        });
    }

    currentPlan() {
        return this.select(user => {
            return user.plan;
        });
    }
    /*i have added this function to set the valueee of roleList API and i am calling this
   function in home page and get the result of it to use in other component to reduce the call of API*/
 setRole(role: any) {
  this.store.update(state => ({
    ...state,
    role: role
  }));
}
getRole(): Observable<any> {
  return this.select(state => state.role);
}
    setCurrentPlan(planId) {
        this.store.update(state => {
            return {
                ...state,
                plan: planId
            }
        });
    }

    currentSession() {
        const ob = new Observable(r => {
            r.next();
        });
        return ob.pipe(
            take(1),
            switchMap(res => {
                return Auth.currentAuthenticatedUser();
            }),
            switchMap((res: any) => {
                if (res) {
                    return of(res)
                } else {
                    this.logout();
                    throwError(false)
                }
            })
        );
    }

    validateUser() {
        const token = this.getToken();
    }

    setUser(data) {
        this.store.update(state => {
            return {
                isLoggedIn: true,
                data: data
            }
        });
    }

    setUserImg(img) {
        this.store.update(state => {
            return {
                ...state,
                data: {
                    ...state.data,
                    profileImg: img
                }
            }
        });
    }

    removeUser() {
        this.cookie.remove(this.tokenName);
        this.clearRegion();

        this.store.update(state => {
            return {
                isLoggedIn: false,
                data: null
            }
        })
    }

    logout(broadcast: boolean = true) {
        // Clear app storage
        localStorage.clear();
        sessionStorage.clear();

        // Expire all cookies for current domain/path
        const cookies = document.cookie.split(';');
        const hostname = window.location.hostname;
        for (const cookie of cookies) {
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
            if (!name) {
                continue;
            }
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${hostname}`;
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${hostname}`;
        }

        this.removeUser();
        if (broadcast) {
            const payload = `${Date.now()}`;
            localStorage.setItem('onecg_logout', payload);
            if (typeof BroadcastChannel !== 'undefined') {
                const channel = new BroadcastChannel('onecg_logout');
                channel.postMessage(payload);
                channel.close();
            }
        }
        this.router.navigateByUrl('/');
    }
        set setRegion(value: string) {
  const normalizedRegion = this.normalizeRegion(value);
  this._region = normalizedRegion;

  if (normalizedRegion) {
    this.cookie.put(this.regionName, normalizedRegion);
    if (typeof window !== 'undefined') {
      localStorage.setItem(this.regionName, normalizedRegion);
    }
    return;
  }

  this.clearRegion();
}

get getRegion(): string {
  if (!this._region) {
    this._region = this.resolveRegion();
  }

  return this._region;
}

    syncRegionFromUrl(url?: string): string {
        const region = this.extractRegionFromUrl(url);
        if (region) {
            this.setRegion = region;
        }

        return this.getRegion;
    }

    getRegionVariant(separator: '_' | '-' = '_'): string {
        const region = this.getRegion;
        if (!region) {
            return '';
        }

        return separator === '-' ? region.replace(/_/g, '-') : region.replace(/-/g, '_');
    }
      getSamlUser(){
        return this.cookie.get(this.SamlUserKey);
    }
    setSamlUser(SamlUser){
       return this.cookie.put(this.SamlUserKey, SamlUser);
    }
    setMemmbershipAPIRes(MemberShipAPIRes){
this.MemberShipAPIRes=MemberShipAPIRes
    }
    getMembershipRes(){
        return this.MemberShipAPIRes;
    }
     setMessage(msg: string) {
    this.message = msg;
  }

  getMessage() {
    return this.message;
  }

  private resolveRegion(): string {
    const urlRegion = this.extractRegionFromUrl();
    if (urlRegion) {
      return urlRegion;
    }

    const cookieRegion = this.normalizeRegion(this.cookie.get(this.regionName));
    if (cookieRegion) {
      return cookieRegion;
    }

    if (typeof window !== 'undefined') {
      const localStorageRegion = this.normalizeRegion(localStorage.getItem(this.regionName));
      if (localStorageRegion) {
        return localStorageRegion;
      }

      const ancestorRegion = this.extractRegionFromAncestorOrigin();
      if (ancestorRegion) {
        return ancestorRegion;
      }
    }

    return '';
  }

  private extractRegionFromUrl(url?: string): string {
    const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
    if (!currentUrl) {
      return '';
    }

    try {
      const parsedUrl = new URL(currentUrl);
      const searchRegion = this.normalizeRegion(parsedUrl.searchParams.get('region'));
      if (searchRegion) {
        return searchRegion;
      }

      const hashSegments = (parsedUrl.hash || '').split('#').filter(Boolean);
      for (const segment of hashSegments) {
        const hashRegion = this.normalizeRegion(new URLSearchParams(segment).get('region'));
        if (hashRegion) {
          return hashRegion;
        }
      }
    } catch (error) {
      // Ignore malformed URLs and try the fallback parser below.
    }

    const hashSegments = currentUrl.split('#').slice(1);
    for (const segment of hashSegments) {
      const hashRegion = this.normalizeRegion(new URLSearchParams(segment).get('region'));
      if (hashRegion) {
        return hashRegion;
      }
    }

    return '';
  }

  private extractRegionFromAncestorOrigin(): string {
    if (typeof window === 'undefined' || !window.location.ancestorOrigins || !window.location.ancestorOrigins.length) {
      return '';
    }

    try {
      const ancestorUrl = new URL(window.location.ancestorOrigins[0]);
      const hostname = ancestorUrl.hostname.replace(/^apps\./, '');
      return this.mapPureCloudHostToRegion(hostname);
    } catch (error) {
      return '';
    }
  }

  private mapPureCloudHostToRegion(hostname: string): string {
    switch (hostname.replace(/\/$/, '')) {
      case 'euw2.pure.cloud':
        return 'eu_west_2';
      case 'mypurecloud.ie':
        return 'eu_west_1';
      case 'mypurecloud.de':
        return 'eu_central_1';
      case 'cac1.pure.cloud':
        return 'ca_central_1';
      case 'usw2.pure.cloud':
        return 'us_west_2';
      case 'mypurecloud.com':
        return 'us_east_1';
      case 'aps1.pure.cloud':
        return 'ap_south_1';
      case 'apne2.pure.cloud':
        return 'ap_northeast_2';
      case 'mypurecloud.com.au':
        return 'ap_southeast_2';
      case 'mypurecloud.jp':
        return 'ap_northeast_1';
      case 'use2.us-gov-pure.cloud':
        return 'us_east_2';
      default:
        return '';
    }
  }

  private normalizeRegion(region: string | null | undefined): string {
    return (region || '').trim().replace(/-/g, '_');
  }

  private clearRegion(): void {
    this._region = '';
    this.cookie.remove(this.regionName);

    if (typeof window !== 'undefined') {
      localStorage.removeItem(this.regionName);
    }
  }

}
